var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.58231L14.2894 6.29289C14.6813 5.90101 15.3171 5.90257 15.7071 6.29637L17.2851 7.88994C17.6724 8.28101 17.6708 8.9115 17.2816 9.30067L16 10.5823L13 7.58231ZM12 8.58231L6 14.5823L9 17.5823L15 11.5823L12 8.58231ZM6 17.5823V14.5823L9 17.5823H6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcn);
export default __webpack_public_path__ + "static/media/edit-icn.aac750c51e3867865dd405f7c6680881.svg";
export { ForwardRef as ReactComponent };